import React, { Component, Fragment } from "react";
import Menu from "../../components/menu";
import config from "../../common/config";
import app from "../../common/app";
import { Redirect, NavLink } from "react-router-dom";

import arrMenu from "./../../constants/menuRoutes";
class TourEnd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirect: false,
    };
  }

  componentDidMount = () => {
    let mainElem = document.getElementById("si-main");
    mainElem.classList.contains(config.zIndClass) &&
      mainElem.classList.remove(config.zIndClass);
  };

  componentWillUnmount = () => {
    // document.getElementById("si-main").classList.remove("si-static");
  };

  redirectTo(sPath, isRedirect) {
    let self = this;
    self.setState({ redirectPath: sPath, isRedirect: isRedirect });
  }

  gotoLeaderboard = () => {
    this.redirectTo("/leaderboard", true);
  };

  render() {
    if (this.state.isRedirect) {
      return (
        <Redirect
          to={{
            pathname: this.state.redirectPath,
          }}
          push
        />
      );
    }
    return (
      <Fragment>
        <Menu />

        <div className="si-main__container--fluid">
          <div className="si-main__container">
            <div className="si-hp__ct">
              <div className="si-wrap">
                <div className="si-wrap__lft">
                  <div className="si-hp__row">
                    <div className="si-hp__col si-hp__col-lft">
                      <div className="si-hp__card si-hp__card-primary si-hp__card-eot">
                        <div className="si-hp__card-top">
                          <div className="si-hp__card-head">
                            {" "}
                            {config.trans && config.trans.quizhasNowEnded
                              ? config.trans.quizhasNowEnded
                              : "The quiz has now ended."}
                          </div>
                          <div className="si-hp__card-sub-head">
                            <div>
                              {config.trans && config.trans.weThankYouForPart
                                ? config.trans.weThankYouForPart
                                : "We thank you for your participation."}
                            </div>

                            <div>
                              {config.trans && config.trans.winnersWillBeCont
                                ? config.trans.winnersWillBeCont
                                : "Winners will be contacted soon"}
                            </div>
                          </div>
                        </div>
                        <div className="si-hp__card-btm">
                          <div
                            className="si-btn si-btn__secondary"
                            onClick={this.gotoLeaderboard}
                          >
                            {config.trans && config.trans.viewLeaderbaord
                              ? config.trans.viewLeaderbaord
                              : "View leaderboard"}
                          </div>
                        </div>
                      </div>
                      <div className="si-hp__ad si-hidden-web">
                        <div className="si-ad__wrap">
                          <div className="si-ad__banner si-ad--mob">
                            <img
                              src={`${config.IMG_BASE}adbanner-mob.png?v=${config.ImgVersion}`}
                              alt="adbanner-mob"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="si-wrap__rgt">
                  <div className="si-hp__col si-hp__col-lft si-hidden-mob">
                    <div className="si-ad__wrap">
                      <div className="si-ad__banner si-ad--web">
                        <img
                          src={`${config.IMG_BASE}adbanner-web.png?v=${config.ImgVersion}`}
                          alt="adbanner-web"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default TourEnd;
